/**
 * @generated SignedSource<<58670a2642a23703905e13b48bf1fb41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderLoyaltyRewardStatus = "AVAILABLE" | "REQUIRES_ORDER_ITEM" | "UNAVAILABLE";
export type OrderStatus = "CANCELED" | "DRAFT" | "EMPTY" | "FULLY_PAID" | "FULLY_REFUNDED" | "OPEN" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED";
export type SquareLoyaltyRewardStatus = "DELETED" | "ISSUED" | "REDEEMED";
export type RemoveLoyaltyRewardInput = {
  squareLoyaltyRewardId: string;
};
export type PatronCheckoutLoyaltyRewardsRemoveMutation$variables = {
  input: RemoveLoyaltyRewardInput;
};
export type PatronCheckoutLoyaltyRewardsRemoveMutation$data = {
  readonly removeLoyaltyReward: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
    } | null | undefined>;
    readonly order: {
      readonly availableLoyaltyRewards: {
        readonly balance: number;
        readonly rewardTiers: ReadonlyArray<{
          readonly rewardTier: {
            readonly id: string;
            readonly name: string;
            readonly points: number;
          };
          readonly status: OrderLoyaltyRewardStatus;
        }>;
        readonly terminologyOne: string;
        readonly terminologyOther: string;
      } | null | undefined;
      readonly bookings: ReadonlyArray<{
        readonly id: string;
        readonly totalDueAfterCredits: number | null | undefined;
      } | null | undefined> | null | undefined;
      readonly expectedLoyaltyPoints: number | null | undefined;
      readonly id: string;
      readonly orderOwner: {
        readonly club: {
          readonly timeZone: string;
        };
        readonly squareLoyaltyAccount: {
          readonly expiringPointDeadlines: ReadonlyArray<{
            readonly expiresAt: string;
            readonly id: string;
            readonly points: number;
          }>;
        } | null | undefined;
      } | null | undefined;
      readonly squareLoyaltyRewards: ReadonlyArray<{
        readonly id: string;
        readonly loyaltyAccount: {
          readonly id: string;
        } | null | undefined;
        readonly loyaltyCustomerId: string | null | undefined;
        readonly points: number;
        readonly rewardTier: {
          readonly id: string;
          readonly name: string;
        };
        readonly status: SquareLoyaltyRewardStatus;
      }>;
      readonly status: OrderStatus | null | undefined;
      readonly total: number | null | undefined;
      readonly totalDiscount: number | null | undefined;
      readonly totalTaxes: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"PatronCheckoutLoyaltyRewardsBookingProjection_order">;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type PatronCheckoutLoyaltyRewardsRemoveMutation = {
  response: PatronCheckoutLoyaltyRewardsRemoveMutation$data;
  variables: PatronCheckoutLoyaltyRewardsRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaxes",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalDiscount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalDueAfterCredits",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expectedLoyaltyPoints",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareLoyaltyAccountExpiringPointDeadline",
  "kind": "LinkedField",
  "name": "expiringPointDeadlines",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiresAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderAvailableLoyaltyRewards",
  "kind": "LinkedField",
  "name": "availableLoyaltyRewards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "balance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "terminologyOne",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "terminologyOther",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderLoyaltyRewardTier",
      "kind": "LinkedField",
      "name": "rewardTiers",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareLoyaltyRewardTier",
          "kind": "LinkedField",
          "name": "rewardTier",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v14/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  (v4/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareLoyaltyReward",
  "kind": "LinkedField",
  "name": "squareLoyaltyRewards",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v11/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "loyaltyCustomerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareLoyaltyAccount",
      "kind": "LinkedField",
      "name": "loyaltyAccount",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareLoyaltyRewardTier",
      "kind": "LinkedField",
      "name": "rewardTier",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PatronCheckoutLoyaltyRewardsRemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveLoyaltyRewardPayload",
        "kind": "LinkedField",
        "name": "removeLoyaltyReward",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Order",
            "kind": "LinkedField",
            "name": "order",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "bookings",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "orderOwner",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SquareLoyaltyAccount",
                    "kind": "LinkedField",
                    "name": "squareLoyaltyAccount",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/),
              (v17/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatronCheckoutLoyaltyRewardsBookingProjection_order"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PatronCheckoutLoyaltyRewardsRemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveLoyaltyRewardPayload",
        "kind": "LinkedField",
        "name": "removeLoyaltyReward",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Order",
            "kind": "LinkedField",
            "name": "order",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "bookings",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectedCreditApplication",
                    "kind": "LinkedField",
                    "name": "projectedCreditApplications",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paymentSource",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareGiftCard",
                        "kind": "LinkedField",
                        "name": "squareGiftCard",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ganLastFour",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Raincheck",
                        "kind": "LinkedField",
                        "name": "raincheck",
                        "plural": false,
                        "selections": (v16/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "orderOwner",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SquareLoyaltyAccount",
                    "kind": "LinkedField",
                    "name": "squareLoyaltyAccount",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v15/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d5fd026473e5758ef8e69caf51786d9",
    "id": null,
    "metadata": {},
    "name": "PatronCheckoutLoyaltyRewardsRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation PatronCheckoutLoyaltyRewardsRemoveMutation(\n  $input: RemoveLoyaltyRewardInput!\n) {\n  removeLoyaltyReward(input: $input) {\n    success\n    errors {\n      __typename\n      code\n    }\n    order {\n      id\n      status\n      total\n      totalTaxes\n      totalDiscount\n      bookings {\n        __typename\n        id\n        totalDueAfterCredits\n      }\n      expectedLoyaltyPoints\n      orderOwner {\n        squareLoyaltyAccount {\n          expiringPointDeadlines {\n            id\n            points\n            expiresAt\n          }\n          id\n        }\n        club {\n          timeZone\n          id\n        }\n        id\n      }\n      availableLoyaltyRewards {\n        balance\n        terminologyOne\n        terminologyOther\n        rewardTiers {\n          status\n          rewardTier {\n            id\n            name\n            points\n          }\n        }\n      }\n      squareLoyaltyRewards {\n        id\n        points\n        status\n        loyaltyCustomerId\n        loyaltyAccount {\n          id\n        }\n        rewardTier {\n          id\n          name\n        }\n      }\n      ...PatronCheckoutLoyaltyRewardsBookingProjection_order\n    }\n  }\n}\n\nfragment PatronCheckoutLoyaltyRewardsBookingProjection_order on Order {\n  bookings {\n    __typename\n    id\n    totalDueAfterCredits\n    projectedCreditApplications {\n      amount\n      paymentSource\n      squareGiftCard {\n        id\n        ganLastFour\n      }\n      raincheck {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "935ec6852b1ae9d132026cc2f512e1d5";

export default node;
